import actions from './actions';
import getters from './getters';
import mutations from './mutations';

const state = {
  messages: [],
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};



// WEBPACK FOOTER //
// ./src/store/modules/chat/index.js